import { useContext, useEffect, useState } from 'react';
import { DataContext } from '../data/DataContext';
import { RadioButton, DropDown, Input, InputLoading } from '../components';
import { catVehicleBrand, catVehicleStatus, catVehicleDevice } from '../data/MochaData'


const Step3 = () => {
    const { AutoCR, setAutoCR, changeHandler } = useContext(DataContext);
    const onChange = (property: string, value: string) => setAutoCR({ ...AutoCR, [property]: value });
    const [loadingValue, setLoadingValue] = useState(false);


    useEffect(() => {      
        if (!AutoCR.isEdit)
            setAutoCR({ ...AutoCR, deductible: '' })   
    }, [AutoCR.vehicleValue])

  
    const GetDeduccibles = () => {
        const { catDeductible, vehicleValue } = AutoCR;
        return catDeductible.filter(d => {
            const min = d.min ?? 0;
            const max = d.max ?? 0;    
            return (min === 0 && max === 0) || (min < vehicleValue && max >= vehicleValue);
        });
    }

    return (
        <>

            <DropDown
                label='Seleccione plan a cotizar'
                field='plan'
                valueSelect={AutoCR.plan}
                dataProvider={AutoCR.catPlanConfig}
                onChangeSelect={onChange}
                readonly={AutoCR.isEdit}
            />

            <RadioButton
                label='Seleccione la marca'
                catalog={catVehicleBrand}
                value={AutoCR.vehicleBrand}
                field='vehicleBrand'
                onChangeStr={onChange}
                onChange={() => { }}
                readonly={AutoCR.isEdit}
            />

            {AutoCR.vehicleBrand === '0' &&
                <DropDown
                    label='Ver todas las marcas'
                    field='otherVehicleBrand'
                    valueSelect={AutoCR.otherVehicleBrand}
                    dataProvider={AutoCR.catBranch}
                    onChangeSelect={onChange}
                    readonly={AutoCR.isEdit}
                />
            }
            <DropDown
                label='Modelo'
                field='vehicleModel'
                valueSelect={AutoCR.vehicleModel}
                dataProvider={AutoCR.catModel}
                onChangeSelect={onChange}
                hasDescription
                readonly={AutoCR.isEdit}
            />
            <DropDown
                label='Año'
                field='vehicleYear'
                valueSelect={AutoCR.vehicleYear}
                dataProvider={AutoCR.catYear}
                onChangeSelect={onChange}
                readonly={AutoCR.isEdit}
            />

            <RadioButton
                label='Estado del vehículo'
                catalog={catVehicleStatus}
                value={AutoCR.vehicleStatus}
                field='vehicleStatus'
                onChangeStr={onChange}
                onChange={() => { }}
                useToolTip
                textToolTip='Se considera vehículo nuevo, todo aquel que al momento de la cotización tenga 0km.'
                titleToolTip='Estado del vehículo'
            />

            <DropDown
                label='Uso del vehículo'
                field='vehicleUse'
                valueSelect={AutoCR.vehicleUse}
                dataProvider={AutoCR.catUse}
                onChangeSelect={onChange}
            />

            <RadioButton
                label='Dispositivos del vehículo'
                catalog={catVehicleDevice}
                value={AutoCR.vehicleDevice}
                field='vehicleDevice'
                onChangeStr={onChange}
                onChange={() => { }}
            />

            <Input
                label='Valor del vehículo'
                value={AutoCR.vehicleValue}
                type='CURRENCY_FORMAT'
                onChange={onChange}
                field='vehicleValue'
                id='vehicleValue'
                prefix={AutoCR.currency}
                isReadOnly={AutoCR.currency === ''}
            />
            {loadingValue === false &&
                <DropDown
                    label='Deducibles'
                    field='deductible'
                    valueSelect={AutoCR.deductible}
                    //dataProvider={AutoCR.catDeductible.filter(x => (x.max ?? 0) >= AutoCR.vehicleValue && (x.min ?? 0) <= AutoCR.vehicleValue)}
                     dataProvider={GetDeduccibles()}
                    onChangeSelect={onChange}
                />
            }
            {loadingValue === true &&
                <InputLoading label='Deducibles' isRequired />
            }

        </>
    );
}

export { Step3 }